import { render } from "./DescontosAlunos.vue?vue&type=template&id=09cac312&scoped=true"
import script from "./DescontosAlunos.vue?vue&type=script&lang=js"
export * from "./DescontosAlunos.vue?vue&type=script&lang=js"

import "./DescontosAlunos.vue?vue&type=style&index=0&id=09cac312&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cac312"]])

export default __exports__